import React, {useState, useEffect} from 'react';

import "./MyProblems.css";
import {StandardButton} from "../../common/button/standard-button/StandardButton";
import problemIcon from "../../../resources/images/problem-icon.png";
import {findProblemsByCriteria} from "../../../services/ProblemService";

export const MyProblems = ({context, setContext, navigateTo, setSpinnerText, showToaster}) => {

    const [problemList, setProblemList] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            setSpinnerText("Retrieving Problems");
            const searchInput = {
                personName: context.loggedInUser.firstName + " " + context.loggedInUser.lastName,
            }

            const [data, error] = await findProblemsByCriteria(context.username, searchInput);
            if (data) {
                if (data.responseStatus === "Success") {
                    setProblemList(data.trackerSearchTableItems);
                } else {
                    showToaster(data);
                }
            } else {
                showToaster({
                    responseStatus: "Error",
                    responseMessage: error.message,
                });
            }
            setSpinnerText(null);
        }
        fetchData();
    }, []);

    const handleListItemClick = (problem) => {
        setContext((prevState) => ({
            ...prevState,
            problemToBeViewedExternalReference: problem.externalReference,
        }));
        navigateTo("problemTree");
    }

    const problemListItems = problemList.map((problem, index) => {
        const colorList = ["#04B14B", "#C8242C", "#5C9AD2", "#A7CE39", "#9A268E"];

        if (colorList[index]) {
            return (
                <div className="my-problems-list-item" key={index}>
                    <div className="my-problems-list-item-bullet"
                         style={{borderLeft: `20px solid ${colorList[index]}`}}>
                    </div>
                    <p className="my-problems-list-item-text" onClick={() => {
                        handleListItemClick(problem)
                    }}>{problem.problemTitle}</p>
                </div>
            );
        }
    });

    return (
        <div className="wizard-content-container">
            <div className="wizard-main-content-container">
                <div className="wizard-left-container">
                    <div className="wizard-icon-container">
                        <img src={problemIcon} alt="Aurum Logo" className="wizard-icon"/>
                    </div>
                    <p className="wizard-icon-label">My Problems</p>
                </div>
                <div className="wizard-right-container">
                    <div className="my-problems-list-container">
                        <h2>Please Choose a Problem</h2>
                        {problemListItems}
                        {problemListItems.length === 0 && <p className="my-problems-message">No Recent Problems</p>}
                        <StandardButton text="Search Problems" onClick={() => {
                            navigateTo("problemSearch");
                        }}/>
                    </div>
                </div>
            </div>
        </div>
    );
}
